import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarItems } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VCard,[_c(VToolbar,{attrs:{"dark":_vm.dark,"dense":"","color":_vm.color}},[_c(VToolbarTitle,[_vm._t("title")],2),_c('div',{staticClass:"flex-grow-1"}),_c(VToolbarItems,[_vm._t("bar-actions")],2)],1),_c(VCardText,{staticClass:"pa-2"},[_c(VRow,[_c(VCol,[_vm._t("default")],2)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }